import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgProtectGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.17 13.215a3.955 3.955 0 1 0 0 7.91 3.955 3.955 0 0 0 0-7.91Zm-5.205 3.955a5.205 5.205 0 1 1 10.41 0 5.205 5.205 0 0 1-10.41 0ZM22.616 17.42l1.73.24-.172 1.239-1.73-.24.172-1.238ZM8.162 15.45l1.74.23-.164 1.24-1.74-.23.164-1.24ZM20.547 21.901l1.06 1.39-.994.758-1.06-1.39.994-.758ZM11.739 10.293l1.05 1.39-.998.754-1.05-1.39.998-.754ZM15.92 23.612l-.23 1.73-1.24-.164.23-1.73 1.24.164ZM17.9 9.165l-.24 1.74-1.24-.17.24-1.74 1.24.17ZM11.439 21.547l-1.39 1.06-.758-.994 1.39-1.06.758.994ZM23.047 12.739l-1.39 1.05-.754-.998 1.39-1.05.754.998Z",
    fill: "currentColor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.265 14.887a75.294 75.294 0 0 0-9.824-.632c-.554 0-1.105.017-1.663.035h-.015c-.55.018-1.107.035-1.663.035v-1.25c.536 0 1.077-.017 1.633-.034h.006c.555-.018 1.124-.036 1.7-.036a76.556 76.556 0 0 1 10.536.716l.54.074v12.633a11.206 11.206 0 0 1-5.486 9.67l-5.589 3.308-5.599-3.309a11.205 11.205 0 0 1-5.486-9.668V26.3h1.25v.132a9.955 9.955 0 0 0 4.873 8.59l4.962 2.932 4.951-2.931a9.955 9.955 0 0 0 4.874-8.591V14.887Z",
    fill: "currentColor"
  }), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.685 26.3v-7.54h1.25v7.54",
    fill: "currentColor"
  }));
}

export { SvgProtectGlyph as default };
